import { EDUCATION } from "../../data/constans";

const Education = () => {
  const keepTailwindClasse = ["order-1", "order-2", "order-3", "order-4"];
  return (
    <div className="bg-white">
      <div className="mx-auto w-[100%] lg:py-8">
        <div className="flex flex-col items-center justify-center">
          {/* DESKTOP */}
          <div className="hidden lg:block">
            <div className="relative flex items-center justify-center">
              {/* TIMELINE */}
              <div className="absolute h-[2px] w-full bg-blue-200"></div>
              {/* EDUCATION DATA */}
              <div className="flex h-[300px] w-[90%] items-center justify-center">
                {EDUCATION.slice()
                  .reverse()
                  .map((edu, index) => (
                    <div key={index} className={`relative ${index % 2 === 0 ? "-translate-y-1/2" : "translate-y-1/2"}`}>
                      <div>
                        <div className="flex w-full flex-col">
                          <h6 className={`${index % 2 === 0 ? "order-1" : "order-3"} mb-2 font-semibold text-blue-500`}>
                            {edu.name}
                          </h6>
                          <p className={`${index % 2 === 0 ? "order-2" : "order-4"} mb-2 font-light text-blue-500`}>
                            {edu.school}
                          </p>
                          <p className={`${index % 2 === 0 ? "order-3" : "order-2"} font-light text-blue-500`}>
                            {edu.year}
                          </p>
                          <div
                            className={`${index % 2 === 0 ? "order-4 translate-y-1/2" : "order-1 -translate-y-1/2"} size-2 rounded-full bg-blue-500`}
                          ></div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {/* MOBILE */}
          <div className="mx-auto flex w-full flex-col items-center justify-center px-20 lg:hidden">
            {EDUCATION.map((edu, index) => (
              <div key={index} className="mb-8 flex flex-wrap lg:w-full lg:justify-center xl:gap-16">
                <div className="w-full lg:w-1/4">
                  <p className="mb-2 text-center text-sm text-blue-500 lg:text-right">{edu.year}</p>
                </div>
                <div className="w-full max-w-xl text-center lg:w-3/4 lg:pl-40 xl:pl-14">
                  <h6 className="mb-2 font-semibold text-blue-500">{edu.name}</h6>
                  <p className="mb-4 text-blue-500">{edu.school}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
